import type { TenantBillingSummary } from "../../types/billing";

// Display model for the billing page's COACHING SESSIONS card. total is the
// tenant's tier baseline (tier_definition.included_coaching_sessions); used =
// total - remaining. The backend already clamps used/remaining into [0, total],
// so this only shapes the values for rendering. total === 0 means the tier
// includes no coaching sessions (`included: false`).
export type CoachingSegment = {
  readonly key: "used" | "free";
  readonly used: boolean;
  readonly count: number;
  readonly pct: number;
};

export type CoachingUsage = {
  readonly total: number;
  readonly used: number;
  readonly remaining: number;
  readonly included: boolean;
  readonly segments: readonly CoachingSegment[];
};

type CoachingFields = Pick<
  TenantBillingSummary,
  "coachingTotal" | "coachingUsed" | "coachingRemaining"
>;

export const coachingUsage = (s: CoachingFields): CoachingUsage => {
  const total = s.coachingTotal;
  const used = s.coachingUsed;
  const remaining = s.coachingRemaining;
  const pctOf = (n: number): number => (total > 0 ? (n / total) * 100 : 0);
  const segments = (
    [
      { key: "used", used: true, count: used },
      { key: "free", used: false, count: remaining },
    ] as const
  )
    .filter((seg) => seg.count > 0)
    .map((seg) => ({ ...seg, pct: pctOf(seg.count) }));
  return { total, used, remaining, included: total > 0, segments };
};
